import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewEncapsulation,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core';

import { iconColors, iconSizes } from '../../constants';

@Component({
  selector: 'a360-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IconComponent implements AfterViewInit {
  @Input() icon: string;
  @Input() ext: string;
  @Input() fullIconPath: string;
  @Input() text: string;
  @Input() color: string;
  @Input() hoverColor: string;
  @Input() width: string;
  @Input() height: string;
  @Input() viewBox: string;
  @Input() isHoverEnable: boolean;
  @Input() style: any;
  @Input() styleClass: string;
  @Input() autId?: string;
  @Input() iconTitle: string;
  @Input() isButton: boolean;
  @Input() shouldHideTabIndex = false;

  replacedColor: string;

  constructor(private renderer: Renderer2, private el: ElementRef) {
    this.ext = 'svg';
    this.color = iconColors.WHITE;
    this.hoverColor = iconColors.LIGHT_ORANGE;
    this.width = iconSizes.DEFAULT;
    this.height = iconSizes.DEFAULT;
    this.viewBox = 'auto';
    this.isHoverEnable = false;
  }

  ngAfterViewInit() {
    const svgElement = this.el.nativeElement.querySelector('svg');
    if (svgElement && this.iconTitle) {
      this.renderer.setAttribute(svgElement, 'aria-label', this.iconTitle);
    }
  }

  getReplacedColor(color: string) {
    return color.replace('icon-', '');
  }
}
